import SGPlugins, { type SGPluginContruct } from "../common/SGPlugins";
import { supportsSelector } from '../common/helpers'

let mfaAttached = false

export default () => {
  const plugins: Array<SGPluginContruct> = [
    {
      name: 'checkbox-autosubmit',
      fullName: 'Checkbox Auto Submit',
      file: 'CheckboxAutoSubmit',
    },
    {
      name: 'user-menu-desktop',
      fullName: 'User Menu (desktop)',
      file: 'UserMenu/desktop',
      mediaQuery: '(min-width: 861px)',
    },
    {
      name: 'user-menu-mobile',
      fullName: 'User Menu (mobile)',
      file: 'UserMenu/mobile',
      mediaQuery: '(max-width: 860px)',
    },
    {
      name: 'abbreviations',
      fullName: 'Abbreviations',
      file: 'Abbreviations',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'logout',
      fullName: 'Logout',
      reactive: true,
      file: 'logout',
      attachOnce: true
    },
    {
      name: 'auth',
      fullName: 'Authorization',
      reactive: true,
      file: 'auth',
      attachOnce: true
    },
    {
      name: 'burger',
      fullName: 'Burger Menu',
      file: 'burger',
      hasCSS: true,
      cssIsGlobal: true,
      mediaQuery: '(max-width: 1145px)'
    },
    {
      name: 'live-comments',
      fullName: 'Live Comments',
      file: 'LiveComments',
    },
    {
      name: 'reactssr',
      fullName: 'ReactSSR',
      file: 'ReactSSR',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'sveltessr',
      fullName: 'SvelteSSR',
      file: 'SvelteSSR',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'react-modal',
      fullName: 'React Modal',
      file: 'ReactModalButton',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'footer',
      fullName: 'Desktop Footer',
      file: 'footer'
    },
    {
      name: 'swiper',
      fullName: 'Swiper',
      file: 'Swiper',
      cssFile: 'swiper',
      hasCSS: true,
      cssIsGlobal: true,
      reactive: true,
      attachOnce: true
    },
    {
      name: 'color-scheme',
      fullName: 'Color Scheme',
      file: 'color-scheme',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'search-panel',
      fullName: 'Search Panel',
      file: 'search-panel',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'lazy-video',
      fullName: 'Lazy Video',
      file: 'lazy-video',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'lite-youtube-embed',
      fullName: 'Lite YouTube Embed',
      file: 'lite-youtube-embed',
      selector: 'lite-youtube',
      reactive: true,
      ignoreSchedule: true,
      attachOnce: true,
      hasCSS: true,
      cssIsGlobal: true
    },
    {
      name: 'lightbox',
      fullName: 'Lightbox',
      file: 'lightbox',
      hasCSS: true,
      reactive: true,
      attachOnce: true
    },
    {
      name: 'twitter',
      fullName: 'Twitter Embed',
      file: 'Twitter',
      reactive: true,
    },
    {
      name: 'add-favourite',
      fullName: 'Add to favourite',
      file: 'AddFavourite',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'sg-alert',
      fullName: 'SG Alerts',
      file: 'SgAlert',
      hasCSS: true,
      cssFile: 'sg-alert',
      cssIsGlobal: true,
      reactive: true,
      attachOnce: true
    },
    {
      name: 'share',
      fullName: 'Share Dialog',
      file: 'Share',
    },
    {
      name: 'game-rating',
      fullName: 'Game Rating',
      file: 'game-rating',
      attachOnce: true
    },
    {
      name: 'async-modal',
      fullName: 'Async Modal',
      reactive: true,
      file: 'AsyncModal',
      attachOnce: true
    },
    {
      name: 'textarea-autoresize',
      fullName: 'Textarea Autoresize',
      file: 'textarea-autoresize',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'editorjs',
      fullName: 'EditorJS',
      file: 'EditorJS',
      hasCSS: true,
    },
    {
      name: 'autocomplete',
      fullName: 'Autocomplete Field',
      reactive: true,
      file: 'Autocomplete',
      hasCSS: true,
      cssIsGlobal: true,
      cssFile: 'autocomplete',
      attachOnce: true
    },
    {
      name: 'caption-autosize',
      fullName: 'Caption Autosize',
      file: 'CaptionAutoSize',
    },
    {
      name: 'scroll-into-view',
      fullName: 'Scroll Into View',
      file: 'ScrollIntoView',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'prevent-multiple-clicks',
      fullName: 'Prevent Multiple Clicks',
      file: 'PreventMultipleClicks',
    },
    {
      name: 'code-highlight',
      fullName: 'Code Highlight',
      file: 'highlight',
      hasCSS: true,
      cssIsGlobal: true
    },
    {
      name: 'sg-dropdown',
      fullName: 'Dropdown',
      file: 'dropdown',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'user-subscribe',
      fullName: 'User Subscribe',
      file: 'user-subscribe',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'games-filter',
      fullName: 'Games Filter',
      file: 'games-filter'
    },
    {
      name: 'review-container',
      fullName: 'Review Container',
      file: 'review-container',
    },
    {
      name: 'static-modal',
      fullName: 'Static Modal',
      file: 'static-modal',
    },
    {
      name: 'toggle-game-notify',
      fullName: 'Toggle Game Notify',
      file: 'game-notifications',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'notifications',
      fullName: 'Notifications',
      file: 'notifications'
    },
    {
      name: 'horizontal-scroll',
      fullName: 'Horizontal Scroll',
      file: 'horizontal-scroll',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'nouislider',
      fullName: 'Slider Input',
      file: 'SliderInput',
      hasCSS: true,
      reactive: true,
      attachOnce: true
    },
    {
      name: 'recaptcha',
      fullName: 'Responsive ReCaptcha',
      file: 'ReCaptcha',
      reactive: true,
      hasCSS: true,
      attachOnce: true
    },
    {
      name: 'form-autosave',
      fullName: 'Form Autosave',
      file: 'Autosave'
    },
    {
      name: 'rating-vote',
      fullName: 'Rating Vote',
      file: 'rating-vote'
    },
    {
      name: 'to-top',
      fullName: 'To Top Button',
      file: 'to-top-button',
      mediaQuery: '(min-width: 1456px)',
    },
    {
      name: 'send-keys',
      fullName: 'Keys Giveaways',
      file: 'send-keys'
    },
    {
      name: 'player-tabs',
      fullName: 'Video Player Tabs',
      file: 'player-tabs'
    },
    {
      name: 'manage-2fa',
      fullName: '2FA Management',
      file: 'manage-2fa',
      shouldRun: function (element = document.body): boolean {
        if (mfaAttached) {
          return false
        }

        this.elements = Array.from(element.querySelectorAll(this.getSelector()))
        const hasElements = this.elements.length > 0

        if (hasElements || window.mandatory2fa) {
          mfaAttached = true
          return true
        }

        return false
      },
    },
    {
      name: 'similar-games',
      fullName: 'Similar Games',
      file: 'similar-games',
      reactive: true,
    },
    {
      name: 'large-sticky',
      fullName: 'Large Sticky',
      file: 'large-sticky',
    },
    {
      name: 'read-more',
      fullName: 'Read More',
      file: 'v9/read-more',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'load-more',
      fullName: 'Load More',
      file: 'v9/load-more',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'load-tab',
      fullName: 'Load Tab',
      file: 'v9/load-tab'
    },
    {
      name: 'tab',
      fullName: 'Tabs',
      file: 'v9/tabs',
    },
    {
      name: 'game-media',
      fullName: 'Game Media',
      file: 'v9/game-media',
    },
    {
      name: 'range-slider',
      fullName: 'Range Slider',
      file: 'v9/range-slider',
      selector: 'input[type="range"]',
      shouldRun: function (element = document.body) {
        if (element.querySelectorAll('input[type="range"]').length > 0 && !supportsSelector('::-moz-range-progress')) {
          return true
        }
      },
      reactive: true
    },
    {
      name: 'favourite-game',
      fullName: 'Favourite Game',
      file: 'v9/favourite-game',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'filters-form',
      fullName: 'Filters Form',
      file: 'v9/filters-form',
      reactive: true,
      attachOnce: true
    },
    {
      name: 'hide-friends-block',
      fullName: 'Hide Friends Block',
      file: 'v9/hide-friends-block',
    },
    {
      name: 'index-games',
      fullName: 'Index Games',
      file: 'v9/index-games',
    }
  ]

  SGPlugins.register(plugins)
}
